import {
  useState, useRef, useLayoutEffect, useCallback,
} from 'react';
import MissingThumbImage from 'assets/images/missing-thumbnail.jpg';
import getThumbnailImageSource from 'library/helpers/get-thumbnail-image-source';

const useImageSource = (image) => {
  const imageRef = useRef(null);
  const [loadedImage, setLoadedImage] = useState({
    src: undefined,
    height: undefined,
    width: undefined,
    isDefault: false,
    id: null,
  });

  const onError = useCallback(() => {
    imageRef.current.src = MissingThumbImage;
  }, []);

  const onLoad = useCallback((e) => {
    setLoadedImage({
      src: e.target.src,
      height: e.target.height,
      width: e.target.width,
      isDefault: MissingThumbImage === e.target.src,
      id: image?.id,
    });

    imageRef.current.removeEventListener('load', onLoad, true);
    imageRef.current.removeEventListener('error', onError, true);
  }, []);
  //
  useLayoutEffect(() => {
    imageRef.current = new Image();

    imageRef.current.addEventListener('load', onLoad, true);
    imageRef.current.addEventListener('error', onError, true);

    return () => {
      imageRef.current.removeEventListener('load', onLoad, true);
      imageRef.current.removeEventListener('error', onError, true);

      imageRef.current = null;
    };
  }, []);

  useLayoutEffect(() => {
    imageRef.current.addEventListener('load', onLoad, true);
    imageRef.current.addEventListener('error', onError, true);

    imageRef.current.src = getThumbnailImageSource(image, true);
  }, [image.id]);

  return loadedImage;
};

export default useImageSource;
